document.addEventListener('DOMContentLoaded', function () {
  // Add CSS to ensure swatches are clickable above card link overlay
  const style = document.createElement('style');
  style.textContent = `
    .card_swatches {
      position: relative;
      z-index: 10;
    }
    .swatch--clickable {
      position: relative;
      z-index: 11;
      cursor: pointer;
    }
  `;
  document.head.appendChild(style);

  // Find and setup all clickable swatches
  const swatches = document.querySelectorAll('.swatch--clickable[data-variant-image-src]');

  swatches.forEach(function (swatch) {
    swatch.addEventListener(
      'click',
      function (e) {
        // Prevent card navigation
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        // Find the card container
        const card = this.closest('.card-wrapper');
        if (!card) return false;

        // Find the product image
        const productImage =
          card.querySelector('.card__media .media img.motion-reduce') ||
          card.querySelector('.media img.motion-reduce') ||
          card.querySelector('img.motion-reduce') ||
          card.querySelector('.card__media img');

        if (!productImage) return false;

        // Get variant image data
        const variantImageSrc = this.dataset.variantImageSrc;
        const variantImageSrcset = this.dataset.variantImageSrcset;
        const variantImageAlt = this.dataset.variantImageAlt;

        // Store original image data for potential future use
        if (!productImage.dataset.originalSrc) {
          productImage.dataset.originalSrc = productImage.src;
          productImage.dataset.originalSrcset = productImage.srcset || '';
          productImage.dataset.originalAlt = productImage.alt || '';
        }

        // Update product image with variant image
        if (variantImageSrc) {
          productImage.src = variantImageSrc + '&width=533';
          if (variantImageSrcset) {
            productImage.srcset = variantImageSrcset;
          }
          if (variantImageAlt) {
            productImage.alt = variantImageAlt;
          }
        }

        // Update swatch active states
        const cardSwatches = card.querySelectorAll('.swatch--clickable');
        cardSwatches.forEach((s) => s.classList.remove('swatch--active'));
        this.classList.add('swatch--active');

        return false;
      },
      true
    );
  });
});
